import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import Header from "../components/Header";
import api from "../components/api";
import { Card, Spinner, Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingBasket, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

const TotalOrder = () => {
    const [countUserOrders, setCountUserOrders] = useState(null); // Initialisé à null pour différencier "0" de "en chargement"
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchOrderCount = async () => {
            const token = localStorage.getItem('token');
            
            if (!token) {
                navigate('/connexion');
                return;
            }

            try {
                const response = await api.get('/user/orders/count', {
                    headers: { Authorization: `Bearer ${token}` },
                });
                
                // On s'assure de récupérer un nombre
                setCountUserOrders(response.data.order_count ?? 0);
            } catch (error) {
                console.error('Erreur lors de la récupération des commandes', error);
                setError("Impossible de charger vos statistiques.");

                if (error.response?.status === 401) {
                    localStorage.clear(); // Plus radical mais sûr
                    navigate('/connexion');
                }
            } finally {
                setLoading(false);
            }
        };

        fetchOrderCount();
    }, [navigate]);

    return (
        <>
            <Header />
            <Container className="mt-5">
                <div className="d-block d-md-none text-start mb-4">
                        <Link
                          to="/dashboard"
                          className="text-decoration-none fw-bold text-orange"
                           style={{color: "#f5721e"}}
                        >
                          <strong>← Tableau de bord</strong>
                        </Link>
                      </div>
                <Row className="justify-content-center">
                    <Col md={6} lg={4}>
                        <Card className="text-center shadow-lg border-0 rounded-4 overflow-hidden">
                            <Card.Header className="bg-primary text-white py-3 border-0">
                                <h4 className="mb-0 fw-bold">Statistiques</h4>
                            </Card.Header>
                            <Card.Body className="py-5">
                                <div className="mb-3">
                                    <FontAwesomeIcon 
                                        icon={faShoppingBasket} 
                                        size="3x" 
                                        className="text-primary opacity-25" 
                                    />
                                </div>
                                <Card.Title className="text-muted text-uppercase small fw-bold mb-3">
                                    Total des Commandes
                                </Card.Title>
                                
                                {loading ? (
                                    <Spinner animation="border" variant="primary" />
                                ) : error ? (
                                    <div className="text-danger small">
                                        <FontAwesomeIcon icon={faExclamationCircle} className="me-2" />
                                        {error}
                                    </div>
                                ) : (
                                    <h2 className="display-4 fw-black text-dark mb-0">
                                        {countUserOrders}
                                    </h2>
                                )}
                            </Card.Body>
                            <Card.Footer className="bg-light border-0 py-3">
                                <small className="text-muted">Mise à jour en temps réel</small>
                            </Card.Footer>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default TotalOrder;